export type SectionId =
    | "overview"
    | "clients"
    | "subscriptions"
    | "sponsored"
    | "marketing"
    | "payouts"
    | "profile";

export type SectionDef = {
    id: SectionId;
    labelKey: string;
    label: string;
    descKey: string;
    desc: string;
    icon: string;
    /** Needs a ready Stripe Connect account to show its data. */
    gated: boolean;
};

export const SECTIONS: SectionDef[] = [
    {
        id: "overview",
        labelKey: "PARTNER_NAV_OVERVIEW",
        label: "Resumen",
        descKey: "PARTNER_NAV_OVERVIEW_DESC",
        desc: "Instalaciones, registros y suscripciones de tus clientes.",
        icon: "fal fa-chart-line",
        gated: true,
    },
    {
        id: "clients",
        labelKey: "PARTNER_NAV_CLIENTS",
        label: "Clientes",
        descKey: "PARTNER_NAV_CLIENTS_DESC",
        desc: "Usuarios que han llegado con tu enlace y vinculación manual.",
        icon: "fal fa-users",
        gated: false,
    },
    {
        id: "subscriptions",
        labelKey: "PARTNER_NAV_SUBSCRIPTIONS",
        label: "Suscripciones",
        descKey: "PARTNER_NAV_SUBSCRIPTIONS_DESC",
        desc: "Suscripciones que tus clientes pagan por su cuenta.",
        icon: "fal fa-credit-card",
        gated: true,
    },
    {
        id: "sponsored",
        labelKey: "PARTNER_NAV_SPONSORED",
        label: "Pagadas por ti",
        descKey: "PARTNER_NAV_SPONSORED_DESC",
        desc: "Suscripciones que pagas tú para tus usuarios.",
        icon: "fal fa-hand-holding-heart",
        gated: false,
    },
    {
        id: "marketing",
        labelKey: "PARTNER_NAV_MARKETING",
        label: "Marketing",
        descKey: "PARTNER_NAV_MARKETING_DESC",
        desc: "Tu código, enlace, QR, creatividades y productos para compartir.",
        icon: "fal fa-bullhorn",
        gated: false,
    },
    {
        id: "payouts",
        labelKey: "PARTNER_NAV_PAYOUTS",
        label: "Cobros",
        descKey: "PARTNER_NAV_PAYOUTS_DESC",
        desc: "Stripe Connect para cobrar comisiones y método de pago para tus suscripciones.",
        icon: "fal fa-wallet",
        gated: false,
    },
    {
        id: "profile",
        labelKey: "PARTNER_NAV_PROFILE",
        label: "Perfil",
        descKey: "PARTNER_NAV_PROFILE_DESC",
        desc: "Datos de tu centro y de tu cuenta.",
        icon: "fal fa-user",
        gated: false,
    },
];

export function isSectionId(v: unknown): v is SectionId {
    return SECTIONS.some((s) => s.id === v);
}

export function sectionDef(id: SectionId): SectionDef {
    return SECTIONS.find((s) => s.id === id) ?? SECTIONS[0]!;
}

export function readSectionFromUrl(): SectionId {
    try {
        const v = new URLSearchParams(window.location.search).get("section");
        return isSectionId(v) ? v : "overview";
    } catch {
        return "overview";
    }
}

/** replaceState, never goTo: the router remounts the page on pushState. */
export function writeSectionToUrl(id: SectionId, drop: string[] = []) {
    try {
        const url = new URL(window.location.href);
        url.searchParams.set("section", id);
        for (const k of drop) url.searchParams.delete(k);
        window.history.replaceState(window.history.state, "", url);
    } catch {
        // ignore
    }
}

/** Remove one-shot return params (connected, refresh, billing...) after use. */
export function stripUrlParams(keys: string[]) {
    try {
        const url = new URL(window.location.href);
        let changed = false;
        for (const k of keys) {
            if (url.searchParams.has(k)) {
                url.searchParams.delete(k);
                changed = true;
            }
        }
        if (changed) window.history.replaceState(window.history.state, "", url);
    } catch {
        // ignore
    }
}
